<script lang="ts" setup>
import { computed, useSlots } from 'vue';
import { RouterLink } from 'vue-router';
import { ArrowUturnLeftIcon } from 'tir-style-system/icons/outline';

/**Параметры */
const props = defineProps({
  /**Путь назад */
  backPath: { type: String },
});
/**Слоты */
const slots = useSlots();

/**Слот заголовка */
const titleSlot = computed(() => slots.title?.());
</script>
<template>
  <div class="titled-layout">
    <div v-if="titleSlot" class="titled-layout_title">
      <slot name="title" />
    </div>
    <div class="titled-layout_body">
      <RouterLink v-if="backPath" class="titled-layout_back" :to="backPath">
        <ArrowUturnLeftIcon class="titled-layout_back_icon" />
        <p class="titled-layout_text-come-back">Назад</p>
      </RouterLink>
      <slot />
    </div>
  </div>
</template>
<style lang="scss" scoped>
.titled-layout {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: 100%;
  padding: 1rem;
  overflow: hidden;
  &_title {
    font-size: 1.25rem;
    font-weight: 600;
    color: var(--text-secondary);
  }
  &_body {
    display: flex;
    flex-direction: column;
    gap: 12px;
    // height: 100%;
    min-height: calc(100vh - 9rem);
    padding: 24px;
    background: var(--bg-base);
    border-radius: 0.5rem;
    max-height: calc(100vh - 9rem);
  }
  &_back {
    display: flex;
    align-items: center;
    gap: 0.375rem;
    max-width: fit-content;
    padding: 0 0.5rem;
    font-size: 0.875rem;
    font-weight: 500;
    color: var(--text-primary, #272d37);
    border-radius: 0.5rem;
    background: var(--bg-base);
    transition: 0.2s linear;
    cursor: pointer;
    &:hover {
      background: var(--neutral-10);
    }
    &_icon {
      width: 1.5rem;
      height: 1.5rem;
    }
  }
}
</style>
